export type ConsoleLogLevel = 'info' | 'warn' | 'error';

export type SystemConsoleSnapshot = {
  checkedAt: string;
  logs: Array<{
    timestamp: string;
    level: ConsoleLogLevel;
    source: string;
    message: string;
  }>;
  host: {
    hostname: string;
    uptimeSeconds: number;
    loadAverage: number[];
    memory: {
      totalBytes: number;
      freeBytes: number;
      usedBytes: number;
    };
    disk: {
      totalBytes: number;
      freeBytes: number;
      usedBytes: number;
    } | null;
  };
  runtime: {
    container: string;
    reverseProxy: string;
    processUptimeSeconds: number;
    rssBytes: number;
    heapUsedBytes: number;
  };
};

export async function loadSystemConsole(): Promise<SystemConsoleSnapshot> {
  const response = await fetch('/api/v1/system/console', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { message?: string; error?: string };
    throw new Error(body.message ?? body.error ?? `System console returned HTTP ${response.status}.`);
  }
  return (await response.json()) as SystemConsoleSnapshot;
}
